<ng-container [ngSwitch]="column.filterType">
  <kendo-grid-numeric-filter-cell
    *ngSwitchCase="'numeric'"
    [showOperators]="false"
    [spinners]="false"
    [column]="gridColumn"
    [filter]="filter"
  ></kendo-grid-numeric-filter-cell>
  <kendo-grid-date-filter-cell
    *ngSwitchCase="'date'"
    [showOperators]="false"
    [column]="gridColumn"
    [filter]="filter"
  ></kendo-grid-date-filter-cell>
  <kendo-grid-boolean-filter-cell
    *ngSwitchCase="'boolean'"
    [column]="gridColumn"
    [filter]="filter"
  ></kendo-grid-boolean-filter-cell>
  <kendo-grid-string-filter-cell
    *ngSwitchCase="'text'"
    [showOperators]="false"
    [column]="gridColumn"
    [filter]="filter"
  ></kendo-grid-string-filter-cell>
  <ng-container *ngSwitchCase="'custom'">
    <ng-container [ngSwitch]="column.type">
      <kendo-grid-numeric-filter-cell
        *ngSwitchCase="'number'"
        [showOperators]="false"
        [spinners]="false"
        [column]="gridColumn"
        [filter]="filter"
      ></kendo-grid-numeric-filter-cell>
      <kendo-grid-string-filter-cell
        *ngSwitchCase="'string'"
        [showOperators]="false"
        [column]="gridColumn"
        [filter]="filter"
      ></kendo-grid-string-filter-cell>
    </ng-container>
  </ng-container>
</ng-container>
